import { render, staticRenderFns } from "./lightControl.vue?vue&type=template&id=845a776e&"
import script from "./lightControl.vue?vue&type=script&lang=js&"
export * from "./lightControl.vue?vue&type=script&lang=js&"
import style0 from "./lightControl.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports